import { debounce } from '@util/debounce';

const backToTopButton = document.querySelector('.back-to-top-button') as HTMLAnchorElement;
const tableOfContentsToggleButton: HTMLButtonElement | null = document.querySelector('.table-of-contents__toggle-button');
const header = document.querySelector('.header') as HTMLElement;
const headerHeight = header.clientHeight;
const pageHeader = document.querySelector('.page-header') as HTMLElement;
const pageHeaderHeight = pageHeader.clientHeight;
const scrollHeight = headerHeight + pageHeaderHeight;

if ( backToTopButton ) {
    window.addEventListener("scroll", debounce(() => {
        if (window.scrollY > scrollHeight) {
            backToTopButton.hidden = false;

            if (tableOfContentsToggleButton) {
                tableOfContentsToggleButton.classList.add('table-of-contents__toggle-button--next-to-back-to-top-button');
            }
        }
        else if (window.scrollY <= scrollHeight) {
            backToTopButton.hidden = true;

            if (tableOfContentsToggleButton) {
                tableOfContentsToggleButton.classList.remove('table-of-contents__toggle-button--next-to-back-to-top-button');
            }
        }
    }, 20 ));
}
